import {Inject, Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HelperService } from './helper.service';
import { environment } from '../../environments/environment';
import { Category } from '../models/category';
import { map } from 'rxjs/operators';
import { TranslationService } from './translation.service';
import {CITY} from "../tokens";

@Injectable({
    providedIn: 'root'
})
export class CategoryService {
    constructor(
        private translationService: TranslationService,
        private helperService: HelperService,
        private http: HttpClient,
        @Inject(CITY) private injectedCity: string) { }

    getAll(): Observable<Category[]> {
        const city = this.injectedCity ||  this.helperService.getCity();
        const language = this.translationService.language;
        return this.http.get(`${environment.API_URL}venuesType/${city}/${language}`)
            .pipe(map(x => this.mapCategories(x)));
    }

    private mapCategories(input: any): Category[] {
        let types = input['types'].map(y => <Category>{
            id: Number(y['id']),
            name: this.helperService.capitalizeFirstLetter(y['type']),
            link_category: y['link_type'],
            icon: y['icon'],
            seo: y['seo']
        });

        const menu = input['menu'].map(y => <Category>{
            id: Number(y['id']),
            name: this.helperService.capitalizeFirstLetter(y['type']),
            link_category: y['link_type'],
            icon: y['icon']
        });

        const special = input['special'].map(y => <Category>{
            id: Number(y['id']),
            name: this.helperService.capitalizeFirstLetter(y['type']),
            link_category: y['link_type'],
            type_description: y['type_description'],
            icon: y['icon']
        });

        const occasion = input['occasion'].map(y => <Category>{
            id: Number(y['id']),
            name: this.helperService.capitalizeFirstLetter(y['type']),
            link_category: y['link_type'],
            icon: y['icon']
        });

        const combined = types.concat(menu).concat(special).concat(occasion);
        return combined;
    }
}
